import React, { useContext } from 'react';
import classnames from 'classnames';
import { TabContent, Option } from './types';
import { WalletSortAndFilterContext } from './context';
import { OutlinedButton } from 'components/outlined-btn/OutlinedButton';
import { getCardTypeOptions } from './util';

export const CardTypeTab = ({ isActive }: TabContent) => {
    const { activeCardTypeFilter, setActiveCardTypeFilter, resolveCardTypeActiveFilters } =
        useContext(WalletSortAndFilterContext);
    const cardTypeOptions = getCardTypeOptions();

    const setActiveCardType = (cardType: Option) => {
        const updatedFilters: Set<Option> = resolveCardTypeActiveFilters(cardType);

        setActiveCardTypeFilter(updatedFilters);
    };

    return (
        // One equal-width column per option keeps every brand's options on a single row.
        <div
            className={classnames('grid gap-2.5 mt-7', isActive ? '' : 'hidden')}
            style={{ gridTemplateColumns: `repeat(${cardTypeOptions.length}, minmax(0, 1fr))` }}
            data-testid="card-type-options"
        >
            {cardTypeOptions.map((cardType: Option) => (
                <OutlinedButton
                    key={cardType.value}
                    fullWidth
                    active={activeCardTypeFilter.has(cardType)}
                    onClick={() => setActiveCardType(cardType)}
                >
                    {cardType.text}
                </OutlinedButton>
            ))}
        </div>
    );
};
